import DeleteModal from './DeleteModal';
import EditDeleteFooter from './EditDeleteFooter';
import React, { useState } from 'react';
import { api } from '../services/api';

function EditFeedCardFooter({ review, toast, loadReviews }) {
    const [showDelete, setShowDelete] = useState(false);
    const [deleteAnswer, setDeleteAnswer] = useState('');
    const [deleting, setDeleting] = useState(false);

    const closeDelete = () => {
        setShowDelete(false)
    }
    const openDelete = () => {
        setDeleting(false);
        setDeleteAnswer("")
        setShowDelete(true)
    }
    const deleteSurgery = (e) => {
        e.preventDefault();
        setDeleting(true);
        api.deleteSurgery(review.id)
            .then(res => {
                toast("Successfully Deleted")
                closeDelete()
                loadReviews()
            }).finally(() => {
                setDeleting(false);
            })
    }
    return (
        <div>
            <DeleteModal
                deleteAnswer={deleteAnswer}
                setDeleteAnswer={setDeleteAnswer}
                deleteAsset={deleteSurgery}
                showDelete={showDelete}
                deleting={deleting}
                closeDelete={closeDelete}
                assetType="surgery"
            />
            <EditDeleteFooter
                to={`/review/${review.id}/edit`}
                toUpdate={`/${review.id}/update`}
                openDelete={openDelete}
            />
        </div>
    )
}

export default EditFeedCardFooter;